import { convertJsonToOptionList } from '@lsfe/tools';

export const status = [
    { value: 0, label: '待确认' },
    { value: 1, label: '待收货' },
    { value: 2, label: '完成收货' },
    { value: 3, label: '生成中' },
    { value: 4, label: '超时关闭' },
    { value: 5, label: '生成失败' },
    { value: 7, label: '部分收货' },
    { value: 8, label: '已取消' },
    { value: 9, label: '取消中' },
    { value: 10, label: '取消失败' },
    { value: 11, label: '待审核' }
];

export const statusMap = status.reduce((pre, cur) => {
    pre[cur.value] = cur.label;
    return pre;
}, {});

export const skuPriceType = {
    0: '常规',
    1: '赠品',
    2: '预订单'
};

export const storageTemperatureLevel = {
    1: '冷冻',
    2: '冷藏',
    5: '常温',
    7: '热食'
};

// 销售对账单生成周期
export const saleSettlementGeneratePeriod = {
    1: '按日',
    2: '按自然月'
};

export const jointType = {
    1: '餐饮联营',
    2: '标品联营'
};

export const RefundStatus = [
    { value: 10, label: '待确认' },
    { value: 3, label: '待分拣' },
    { value: 12, label: '待退货' },
    { value: 7, label: '已完成' },
    { value: 2, label: '生成失败' },
    { value: 6, label: '已关闭' },
    { value: 5, label: '关闭失败' },
    { value: 14, label: '退货价变更中' }
];

export const RefundStatusMap = {
    0: '草稿',
    1: '生成中',
    2: '生成失败',
    3: '待分拣',
    4: '关闭中',
    5: '关闭失败',
    6: '已关闭',
    7: '已完成',
    8: '已删除',
    9: '待审核',
    10: '待确认',
    11: '待下发',
    12: '待退货',
    14: '退货价变更中'
};

// 退货单状态
export const RefundStatusAll = convertJsonToOptionList(RefundStatusMap);
